module.exports = __webpack_public_path__ + "static/media/green_stress_EN.0bf204ec.png";